import { combineReducers } from 'redux';
import coreReducer from './coreReducer';
import { keysReducer } from './keysReducer';

export const rootReducer = combineReducers({
    core: coreReducer,
    keys: keysReducer
});
